// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChevronRightAligned = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M70 82a1.992 1.992 0 0 1-1.414-.586l-32-32a2 2 0 0 1 0-2.828l32-32a2 2 0 1 1 2.828 2.828L40.829 48l30.585 30.586A2 2 0 0 1 70 82"
			fillRule="evenodd"
		/>
	</svg>
);
export default ChevronRightAligned;
